// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Noto Sans', 'Noto Sans Fallback'"},"className":"__className_1d0cb5"};